module.exports = __webpack_public_path__ + "img/icon-stats.3b7a829d.svg";